export default {
    type: 'pullout',
    name: 'Pullout',
    osOnly: false,
    components: {
        root: {
            name: 'ModulePullout',
            loader: () => import('./ModulePullout')
        },
        form: {
            name: 'ModulePulloutForm',
            loader: () => import('./ModulePulloutForm')
        }
    }
};
